import { render, staticRenderFns } from "./PlanStrengths.vue?vue&type=template&id=ab387254&scoped=true"
import script from "./PlanStrengths.vue?vue&type=script&lang=js"
export * from "./PlanStrengths.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab387254",
  null
  
)

export default component.exports